import { Badge } from "react-bootstrap";
function EstadoModulo({ estado }) {
  const estadoConfig = {
    activo: {
      color: "var(--color-green) !important",
      textColor: "var(--color-text) !important",
      icon: "bi bi-check",
    },
    inactivo: {
      color: "var(--color-red) !important",
      textColor: "var(--color-text) !important",
      icon: "bi bi-x",
    },
    "no-disponible": {
      color: "var(--color-background-3) !important",
      textColor: "var(--color-text) !important",
      icon: "bi bi-slash-circle"
    },
    "no definido": {
      color: "var(--color-background-3)",
      textColor: "var(--color-text)",
      icon: "bi bi-slash-circle",
    },
  };
  const estadoKey = estado?.toLowerCase() || "no definido";
  const { color, textColor, icon } = estadoConfig[estadoKey];
  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  const styles = {
    motivo: {
      backgroundColor: color,
      color: textColor,
    },
  };

  return (
    <Badge style={styles.motivo} className="fw-normal fs-6">
      <i className={`${icon} me-1`}></i>
      {capitalize(estadoKey)}
    </Badge>
  );
}

export default EstadoModulo;
